import React from 'react';

import { Box } from '@mui/material';

import { useRegisterPageContainerError } from '../../../../components/layout/page-container/page-container-error-handler';
import { useRegisterPageRefreshHandler } from '../../../../components/layout/page-container/page-refresh-handler';
import LoadMoreFeedback from '../../../../components/reusable/load-more-feedback/LoadMoreFeedback';
import { useLazyGetPublicExercises } from '../../../../redux/api/exercisesAPI';
import { EXERCISE_FILTERS_PAGE_KEYS } from '../exercise-filters';
import ExerciseList from '../exercise-list/ExerciseList';
import { useExerciseListLazyTab } from '../hooks/useExerciseListLazyTab';

const PublicExercises = () => {
  const {
    exercises,
    isLoading,
    error,
    hasData,
    refetch,
    footerRef,
    handleQueryChange,
    handleRetry,
    isFetching,
  } = useExerciseListLazyTab(useLazyGetPublicExercises, 'public');

  useRegisterPageRefreshHandler(refetch);
  useRegisterPageContainerError({
    errors: error ? [error] : [],
    isLoading,
    hasData,
    onRetry: handleRetry,
  });

  return (
    <ExerciseList
      exercises={exercises}
      filtersPageKey={EXERCISE_FILTERS_PAGE_KEYS.public}
      isLoading={isLoading}
      disableClientFilter
      onQueryChange={handleQueryChange}
      listFooter={
        <>
          <LoadMoreFeedback
            error={error}
            isFetching={isFetching}
            onRetry={handleRetry}
          />
          <Box ref={footerRef} mb={1} />
        </>
      }
    />
  );
};

export default PublicExercises;
